<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
      <p style="font-size:12px;" class="mb-2"> *Recuerda que estos resultados se calculan con base a los valores que nos indicas y datos que son proporcionados por la entidad financiera. Todos los datos están sujetos a validación y su correcta aprobación. <br> Para más información consulta a tu asesor de crédito.</p>
        <p>
          <a href="https://socasesores.com/" target="_blank" rel="nofollow">SOC</a>
        </p>
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        }
    }
}
</script>
